import { Box, Button } from "@mui/material";
import React, { FunctionComponent, ReactNode } from "react";

import { Comment2AlertIcon } from "assets";

import { Dialog } from "./dialog";

import { FLEX_CENTER_POSITIONING_STYLE } from "../consts";

/**
 * Generic confirm/warn-before-you-act modal —
 * it can be reused for any destructive or hard-to-undo action.
 */
export const ConfirmActionModal: FunctionComponent<{
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  children: ReactNode;
  warningMessage?: ReactNode;
  confirmButtonText?: string;
  confirmButtonDisabled?: boolean;
  confirmButtonIcon?: ReactNode;
  cancelButtonText?: string;
}> = ({
  isOpen,
  onCancel,
  onConfirm,
  title,
  children,
  warningMessage = "Warning! This action cannot be undone.",
  confirmButtonText = "Confirm",
  confirmButtonDisabled,
  confirmButtonIcon,
  cancelButtonText = "Cancel",
}) => (
  <Dialog
    title={title}
    isOpen={isOpen}
    onClose={onCancel}
    actions={
      <Box>
        <Button variant="outlined" color="warning" onClick={onCancel}>
          {cancelButtonText}
        </Button>
        <Button
          sx={{ ml: 2 }}
          variant="contained"
          color="error"
          startIcon={confirmButtonIcon}
          onClick={onConfirm}
          disabled={confirmButtonDisabled}
        >
          <span>{confirmButtonText}</span>
        </Button>
      </Box>
    }
  >
    <Box
      sx={{
        backgroundColor: "error.light",
        p: 2,
        borderRadius: 2,
        mb: 3,
        color: "error.main",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box component="span" sx={{ ...FLEX_CENTER_POSITIONING_STYLE, mr: 1 }}>
        <Comment2AlertIcon />
      </Box>
      {warningMessage}
    </Box>
    <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>{children}</Box>
  </Dialog>
);
